/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Latestbuilds1Inputs */

const id_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build Terbaru`)
};

const ms_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan Terkini`)
};

const da_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste Builds`)
};

const de_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste Builds`)
};

const en_us2_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest Builds`)
};

const es_es2_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas compilaciones`)
};

const es_mx2_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas compilaciones`)
};

const fil_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakabagong Build`)
};

const fr_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernières compilations`)
};

const it_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime build`)
};

const hu_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legújabb build-ek`)
};

const nl_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwste builds`)
};

const no_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste builds`)
};

const pl_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze kompilacje`)
};

const pt_br2_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds recentes`)
};

const pt_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas compilações`)
};

const ro_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai recente compilări`)
};

const fi_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät koontiversiot`)
};

const sv_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste byggen`)
};

const vi_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng mới nhất`)
};

const tr_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Yapılar`)
};

const cs_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější sestavení`)
};

const bg_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-нови компилации`)
};

const ru_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние сборки`)
};

const uk_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні збірки`)
};

const ar_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أحدث البنيات`)
};

const hi_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नवीनतम बिल्ड`)
};

const th_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ล่าสุด`)
};

const ja_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新ビルド`)
};

const zh_cn2_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新构建版本`)
};

const zh_hant1_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新建置版本`)
};

const ko_home_sections_latestbuilds1 = /** @type {(inputs: Home_Sections_Latestbuilds1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최신 빌드`)
};

/**
* | output |
* | --- |
* | "Latest Builds" |
*
* @param {Home_Sections_Latestbuilds1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_latestbuilds1 = /** @type {((inputs?: Home_Sections_Latestbuilds1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Latestbuilds1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_latestbuilds1(inputs)
	if (locale === "ms") return ms_home_sections_latestbuilds1(inputs)
	if (locale === "da") return da_home_sections_latestbuilds1(inputs)
	if (locale === "de") return de_home_sections_latestbuilds1(inputs)
	if (locale === "en-US") return en_us2_home_sections_latestbuilds1(inputs)
	if (locale === "es-ES") return es_es2_home_sections_latestbuilds1(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_latestbuilds1(inputs)
	if (locale === "fil") return fil_home_sections_latestbuilds1(inputs)
	if (locale === "fr") return fr_home_sections_latestbuilds1(inputs)
	if (locale === "it") return it_home_sections_latestbuilds1(inputs)
	if (locale === "hu") return hu_home_sections_latestbuilds1(inputs)
	if (locale === "nl") return nl_home_sections_latestbuilds1(inputs)
	if (locale === "no") return no_home_sections_latestbuilds1(inputs)
	if (locale === "pl") return pl_home_sections_latestbuilds1(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_latestbuilds1(inputs)
	if (locale === "pt") return pt_home_sections_latestbuilds1(inputs)
	if (locale === "ro") return ro_home_sections_latestbuilds1(inputs)
	if (locale === "fi") return fi_home_sections_latestbuilds1(inputs)
	if (locale === "sv") return sv_home_sections_latestbuilds1(inputs)
	if (locale === "vi") return vi_home_sections_latestbuilds1(inputs)
	if (locale === "tr") return tr_home_sections_latestbuilds1(inputs)
	if (locale === "cs") return cs_home_sections_latestbuilds1(inputs)
	if (locale === "bg") return bg_home_sections_latestbuilds1(inputs)
	if (locale === "ru") return ru_home_sections_latestbuilds1(inputs)
	if (locale === "uk") return uk_home_sections_latestbuilds1(inputs)
	if (locale === "ar") return ar_home_sections_latestbuilds1(inputs)
	if (locale === "hi") return hi_home_sections_latestbuilds1(inputs)
	if (locale === "th") return th_home_sections_latestbuilds1(inputs)
	if (locale === "ja") return ja_home_sections_latestbuilds1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_latestbuilds1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_latestbuilds1(inputs)
	return ko_home_sections_latestbuilds1(inputs)
});
export { home_sections_latestbuilds1 as "home.sections.latestBuilds" }